require('../../modules/es6.object.keys');
module.exports = require('../../modules/_core').Object.keys;



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/core-js@2.6.12/~/core-js/library/fn/object/keys.js
// module id = 148
// module chunks = 1